import Vue from 'vue'
import Vuetify, {
  VApp,
  VAvatar,
  VBtn,
  VIcon,
  VImg,
  VProgressCircular,
  VTextarea,
  VTextField
} from 'vuetify/lib'

// pp-vue-library components render Vuetify components underneath (PpButton renders
// v-btn, PpInputText renders v-text-field), so Vuetify has to be a real instance on
// the root rather than a stubbed $vuetify object.
//
// Only the components the widget actually renders are registered: the full Vuetify
// build adds ~240 KB gzipped, which is not acceptable on patient browsers. Adopting
// another pp-* component may mean registering the Vuetify components it renders.
Vue.use(Vuetify, {
  components: {
    VApp,
    VAvatar,
    VBtn,
    VIcon,
    VImg,
    VProgressCircular,
    VTextarea,
    VTextField
  }
})

export default function createVuetify (primaryColor) {
  return new Vuetify({
    theme: {
      // The practice color arrives as the `primary` URL param, so the theme is
      // built at boot instead of compile time.
      themes: {
        light: { primary: primaryColor }
      },
      options: { customProperties: true }
    }
  })
}
